import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PortalSession } from '../auth/portal-session.service';
import { RETURN_URL_PARAM, ShellRoutes } from '../portal-routes';
import { ReturnUrlStore } from '../return-url/return-url.store';

/** Public pages for anonymous users only (e.g. registration): an authenticated user goes to the landing route. */
export const anonymousOnlyGuard: CanActivateFn = async () => {
  const session = inject(PortalSession);
  const router = inject(Router);
  return (await session.isValid()) ? router.parseUrl(ShellRoutes.landing) : true;
};

/**
 * Welcome page, the entry into the portal. Its `?returnUrl=` replaces any previously stored deeplink
 * (no parameter means no deeplink), then it behaves like any other anonymous-only page.
 */
export const welcomeGuard: CanActivateFn = (route, state) => {
  inject(ReturnUrlStore).capture(route.queryParamMap.get(RETURN_URL_PARAM));
  return anonymousOnlyGuard(route, state);
};
